<template>
  <container :class="['code-chunk']"><pre :is="pre ? 'pre' : 'span'"><code :class="['text-xs']"><slot /></code></pre></container>
</template>
<script>
export default {
  name: 'CodeChunk',
  props: {
    pre: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/code-chunk.vue